import { useMemo } from 'react';
import { PagesFragment, usePagesQuery, useRegistrySummaryQuery } from '../generated/graphql';
import useIsLiteSite from './useIsLiteSite';
import registryInfo from '../helpers/registryInfo';

export const LITE_SITE_PAGE_TYPE = 'LiteSitePage';
export const SCHEDULE_PAGE = 'SchedulePage';

export const WEDDING_PAGE_TYPE = 'WeddingPage';
export const CUSTOM_PAGE_TYPE = 'CustomPage';
export const REGISTRY_PAGE_TYPE = 'RegistryPage';
export const TRAVEL_PAGE_TYPE = 'TravelPage';
export const THINGS_TO_DO_PAGE_TYPE = 'ThingsToDoPage';
export const QA_PAGE_TYPE = 'QAPage';
export const STORY_PAGE_TYPE = 'StoryPage';
export const PHOTO_PAGE_TYPE = 'PhotoPage';
export const WEDDING_PARTY_PAGE_TYPE = 'WeddingPartyPage';

export const useVisiblePages = (): PagesFragment[] => {
  const { data } = usePagesQuery();
  const isLiteSite = useIsLiteSite();
  const { data: registryData } = useRegistrySummaryQuery();
  const { hasAnyRegistry } = registryInfo(registryData?.registrySummary);

  return useMemo(() => {
    const visiblePages = (data?.pages || []).filter(page => page.show);

    if (isLiteSite) {
      return pagesWithContent(visiblePages, hasAnyRegistry);
    }

    return visiblePages;
  }, [data, isLiteSite, hasAnyRegistry]);
};

export const pagesWithContent = (pages: PagesFragment[], hasAnyRegistry: boolean): PagesFragment[] => {
  return pages.filter(page => {
    const homePage = page.type === LITE_SITE_PAGE_TYPE;
    const visibleRegistryPage = page.type === REGISTRY_PAGE_TYPE && hasAnyRegistry;
    const hasItems = page.items.length;

    return homePage || visibleRegistryPage || hasItems;
  });
};
